import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { STATUSES } from '../constants/common.constants';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private messageService: MessageService) {}

  showErrorToast(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: STATUSES.ERROR,
      detail: message,
      life: 3000,
    });
  }

  showSuccessToast(message: string) {
    this.messageService.add({
      severity: 'success',
      summary: STATUSES.SUCCESS,
      detail: message,
      life: 3000,
    });
  }

  showWarningToast(message: string) {
    this.messageService.add({
      severity: 'warning',
      summary: STATUSES.WARNING,
      detail: message,
      life: 3000,
    });
  }

  showInfoToast(message: string) {
    this.messageService.add({
      severity: 'info',
      summary: STATUSES.INFO,
      detail: message,
      life: 3000,
    });
  }

  clearToasts() {
    this.messageService.clear();
  }
}
